module.exports = __webpack_public_path__ + "static/media/remove.9499f875.svg";